import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService, LaunchDarklyUserGuard } from 'remarketing-angular-library';

/**
 * Guard that matches when the React dashboard remote flag is ENABLED.
 * Used for the remote-profile dashboard route.
 * If this guard returns false, the legacy Angular dashboard route (without this guard) is the fallback.
 *
 * canMatch, not canActivate: LaunchDarklyUserGuard.canActivate redirects the browser when a
 * flag is off rather than resolving false, and canActivate does not fall through to the next
 * route entry at the same path regardless. Only canMatch gives flag-off rollback with no deploy.
 *
 * Mirrors bidlistReactGuard exactly (see src/vehicles/guards/bidlist-react-version.guard.ts).
 */
export const dashboardReactGuard: CanMatchFn = () => {
  const authService = AuthService.getInstance();

  if (!authService.isAuthenticated()) {
    return true;
  }

  return inject(LaunchDarklyUserGuard).canMatch('dashboard-page-enableReact');
};
